import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '@env/environment';
import { InterceptorSkipHeader } from '@core/http/http-headers';
import { TransferResponse } from '@app/types/auth.types';
import { LocalStorageService } from '@core/state/local-storage.service';

export interface Auth {
  email: string;
  password: string;
}

export interface RefreshTokenResponse {
  token?: string;
  accessToken?: string;
  refresh_token?: string;
  refreshToken?: string;
  data?: {
    token?: string;
    accessToken?: string;
    refresh_token?: string;
    refreshToken?: string;
  };
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(
    private readonly http: HttpClient,
    private readonly storage: LocalStorageService
  ) {}

  login(auth: Auth): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/login`, auth, {
      headers: new HttpHeaders().set(InterceptorSkipHeader, ''),
    });
  }

  refresh(): Observable<RefreshTokenResponse> {
    const refreshToken = this.storage.get<string>('refresh_token');
    if (!refreshToken) {
      return throwError(() => new Error('No refresh token available'));
    }

    const connectionId = this.storage.get<string>('connection') ?? '';

    const headers = new HttpHeaders()
      .set(InterceptorSkipHeader, '')
      .set('Authorization', `Bearer ${refreshToken}`)
      .set('connection-id', connectionId);

    return this.http.post<RefreshTokenResponse>(
      `${environment.apiUrl}/refresh`,
      {},
      { headers }
    );
  }

  loginTransfer(vehicle: boolean = false): Observable<TransferResponse> {
    return this.http.post<TransferResponse>(
      `${environment.apiUrl}/login/transfer`,
      { vehicle }
    );
  }

  loginTransferValidate(token: string): Observable<TransferResponse> {
    return this.http.post<TransferResponse>(
      `${environment.apiUrl}/login/transfer/validate`,
      { t: token },
      { headers: new HttpHeaders().set(InterceptorSkipHeader, '') }
    );
  }

  loginWithToken(token: string): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/login`,
      { token },
      { headers: new HttpHeaders().set(InterceptorSkipHeader, '') }
    );
  }

  logout(): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/logout`, {});
  }

  isAuthenticated(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/validateToken`);
  }
}
